export default __webpack_public_path__ + "static/media/bipolar_banner.52295c69.png";